export enum EFeatureFlags {
	EnableDarkMode = 'ENABLE_DARK_MODE',
	Demo = 'DEMO',
}
